
import config from "config";
import AssetsManager from "js/components/AssetsManager";
import { BaseTexture, Container, Graphics, Sprite, Text, TextStyle, Texture } from "pixi.js";
import tools from "tools";

export default class Player extends Container {

    constructor(path, color, score, rank = 88, mainPlayer = false) {

        super();

        this.path = path;
        
        this.color = color;
        this.score = score;
        this._rank = rank;
        this.mainPlayer = mainPlayer;

        this.build();




    }



    build() {

        let cadre = new Sprite(AssetsManager.texturesPixi.cadre);
        cadre.tint = tools.hashtagToHexa(this.color);
        cadre.anchor.set(.5);
        cadre.y = -cadre.height / 2;
        this.addChild(cadre);

        let img;

        if (this.path) {
            img = Sprite.from(this.path);
        } else {
            img = new Sprite(new Texture(new BaseTexture()));
        }
        
        let picto = new Sprite();
        picto.texture = this.path ? img.texture : AssetsManager.texturesPixi.you;
        picto.anchor.set(.5);
        
        let sizeTimer = setInterval(() => {
            if (picto.width > 5) {
                picto.width = 128;
                picto.scale.y = picto.scale.x;
                clearInterval(sizeTimer);
            }
            //console.log("picto.width:", picto.width);
        }, 100);

        // picto.addChild(img);
        cadre.addChild(picto);

        let __mask = new Graphics();
        __mask.beginFill(0xff0000);
        __mask.drawRoundedRect(-130 / 2, -130 / 2, 260 / 2, 260 / 2, 30 / 2);
        __mask.endFill();
        __mask.y = -4;

        picto.mask = __mask;
        cadre.addChild(__mask);

        if (this.score) {

            const style = new TextStyle({
                fontFamily: 'voodoo_casual-bold',
                fontSize: 42,
                fill: '#000000'
            });

            let text = new Text(parseInt(this.score), style);
            text.anchor.set(.5, .9);
            this.addChild(text);
            cadre.y -= text.height * .7;
        }

        this._picto = picto;
        this._cadre = cadre;

        const styleTextRank = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 40,
            fill: '#000000',
            stroke: cadre.tint,
            strokeThickness: 4
        });

        this.textRank = new Text(this._rank, styleTextRank);
        // this.textRank.anchor.set(1.1, 2.1);
        // cadre.addChild(this.textRank);


    }


    get picto() {
        return this._picto;
    }


    get cadre() {
        return this._cadre;
    }

    get texture() {
        return this._picto.texture;
    }

    get rank() {
        return this.textRank.text;
    }


    set rank(val) {
        this.textRank.text = val;
    }


    get img() {
        return this.path
    }



}
